import { Box, type BoxProps, Text } from "@chakra-ui/react";

export const DraftNotice = (props: BoxProps) => (
  <Box display="flex" flexDirection="column" px="20px" py="24px" {...props}>
    <Text
      fontFamily="body"
      color="fg.muted"
      textAlign="center"
      fontSize="14px"
      m="0"
    >
      Registration is not yet available for this event.
    </Text>
  </Box>
);
